<template>
  <form data-vv-scope="vendorHome">
    <div class="form-group">
      <label for="vendorEmail"
													data-test="vendorLoginWindowLabel1"
													id="vendorLoginWindowLabel1">
							Enter your email address</label>
      <input
        v-validate="'required|email'"
        name="vendor Email"
        :class="(showLoginError &&
          errors.has('vendorHome.vendor Email'))?'is-invalid':''"
        v-model="accountCreation.email"
        type="text"
        class="form-control"
        id="vendorEmail"
        aria-describedby="emailHelp"
        placeholder="Enter email"
        autocomplete="off"
								data-test="vendorLoginWindowEmailInput"
      >
      <div
        class="invalid-feedback"
        v-if="(errors.has('vendorHome.vendor Email') && showLoginError)"
        id="login-form-email-error"
								data-test="vendorLoginWindowEmailError"
      >
        {{ errors.first('vendorHome.vendor Email') }}
      </div>
      <small
        id="emailHelp"
        class="form-text text-muted"
								data-test="vendorLoginWindowSublabel"
      >We'll never share your email with anyone else.
      </small>
    </div>
    <button
      type="submit"
      class="btn btn-primary btn-type-primary"
      @click.prevent="action('vendorHome')"
						data-test="vendorLoginWindowBtn"
						id="vendorLoginWindowBtn"
    >
      Continue
    </button>
  </form>
</template>

<script>
export default {
	data () {
		return {
			accountCreation: {
				email: ''
			},
			showLoginError: false
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (result) {
						this.showLoginError = false
						this.$emit('clientStatusResponse', this.accountCreation)
					} else {
						this.showLoginError = true
					}
				})
		}
	}
}
</script>
